import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import CustomCursor from "./components/CustomCursor";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import MarqueeStrip from "./components/MarqueeStrip";
import About from "./components/About";
import Services from "./components/Services";
import Stats from "./components/Stats";
import Partners from "./components/Partners";
import Roster from "./components/Roster";
import ForCreators from "./components/ForCreators";
import ForBrands from "./components/ForBrands";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const Home = () => {
  return (
    <main className="bg-[#050505] text-white" data-testid="home-page">
      <CustomCursor />
      <Navbar />
      <Hero />
      <MarqueeStrip />
      <About />
      <Services />
      <Stats />
      <Partners />
      {/* <Roster /> hidden per request */}
      <ForCreators />
      <ForBrands />
      <Contact />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0c0c0c",
              border: "1px solid rgba(255,255,255,0.12)",
              color: "#fafafa",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
